import { LOG } from 'src/app/common/util/log';
import { TableHeaderGroup } from '../../types';

export function defaultGroupContext(): GroupContext {
  return new GroupContext();
}

export class GroupContext {
  /** group id -> group */
  public columnGroupsByGroupId: Map<string, TableHeaderGroup> = new Map();
  /** column index -> group */
  public columnGroupsByPrimaryColumn: Map<number, TableHeaderGroup> = new Map();

  public groupedColumns: Set<number> = new Set();

  public biggestGroupSize: number = 0;

  public addToGroup(columnIndex: number, groupId: string): void {
    if (this.groupedColumns.has(columnIndex)) {
      LOG.error(`Columns can't be grouped more than once: ${columnIndex}`);
      return;
    }

    this.groupedColumns.add(columnIndex);

    let group: TableHeaderGroup = this.columnGroupsByGroupId.get(groupId);

    if (group) {
      group.secondaryColumns.push(columnIndex);
      this.biggestGroupSize = Math.max(group.secondaryColumns.length + 1, this.biggestGroupSize);
      return;
    }

    group = { primaryColumn: columnIndex, secondaryColumns: [] };

    this.columnGroupsByGroupId.set(groupId, group);
    this.columnGroupsByPrimaryColumn.set(group.primaryColumn, group);

    this.biggestGroupSize = Math.max(1, this.biggestGroupSize);
  }
}
